export default "__VITE_ASSET__B1nuxI_i__"